import strings from '../../Localization/Localization';

import {
  index,
  getFromId,
  editFromId,
  newItem
} from '../../API/AlphalinkMobileProducts';
import { form } from '../Form/alphalinkMobileProduct';
import { form as searchForm } from '../Form/Search/alphalinkMobileProduct';

import { alphalinkMobileProduct as routes } from '../Route/routes';

export const conf = {
  index: {
    id: "alphalinkMobileProduct",
    pageTitle: strings.common.homepage.alphalinkMobileProduct,
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    newLink: {
      link: () => routes.routes.new.createPath(),
      auth: 'ROLE_MVNO_CONFIGURATION'
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(search.name) {
        result["name"] = search.name;
      }
      return result;
    },

    availableItemDisplay:['line'],
    itemDisplay: {
      line: {
        label: (item) => item.name,
      }
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },

    buttons: (item) => []
  },
  show: {
    pageTitle: strings.common.homepage.alphalinkMobileProduct,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: "number",

    apiGet: getFromId,

    extendedHeader: false,

    tabs: {
      main: {
        title: strings.alphalinkMobileProduct.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: (alphalinkMobileProduct) => {
          alphalinkMobileProduct["alphalink_options"] = Object.values(alphalinkMobileProduct["alphalink_options_object"]).flat()
          alphalinkMobileProduct["alphalink_options_object"] = undefined
        },
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_MVNO_CONFIGURATION'],
        editable: ['ROLE_MVNO_CONFIGURATION']
      }
    }
  },
  new: {
    pageTitle: strings.alphalinkMobileProduct.new.title,

    api: newItem,
    empty: {},
    form: form,
    onSubmit: (alphalinkMobileProduct) => {
      alphalinkMobileProduct["alphalink_options"] = Object.values(alphalinkMobileProduct["alphalink_options_object"]).flat()
      alphalinkMobileProduct["alphalink_options_object"] = undefined
    },
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
